import { render, staticRenderFns } from "./regulatoryFooter.vue?vue&type=template&id=5e31fba2&scoped=true&"
import script from "./regulatoryFooter.vue?vue&type=script&lang=js&"
export * from "./regulatoryFooter.vue?vue&type=script&lang=js&"
import style0 from "./regulatoryFooter.vue?vue&type=style&index=0&id=5e31fba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31fba2",
  null
  
)

export default component.exports